<template>
  <div
    class="collection-group"
    @mouseover="toggleCollectionGroupResize(true)"
    @mouseout="toggleCollectionGroupResize(false)"
    @click="handleCollectionClick"
  >
    <CollectionsHeader
      ref="header"
      :name="collection.name"
      :colors="collection.color"
      :itemCount="collection.resourcePks.length"
      :cID="collection.cID"
      @expand="toggleCollectionGroupExpand"
    />
    <div
      v-if="type === 'collections' || type === 'uploads'"
      ref="results"
      class="collection-items"
      :class="pointerEvents"
    >
      <CollectionItem
        v-for="(resource, index) in items"
        :key="resource.id"
        :num="index"
        :expand="selected"
        :resource="resource"
      />

    </div>
  </div>
</template>

<script>
import CollectionItem from '@/components/libraries/search/collection/CollectionItem';
import { gsap } from 'gsap';
import { useRMTStore } from '@/store/RMTStore';
import { mapStores } from 'pinia/dist/pinia';
import CollectionsHeader from '@/components/libraries/search/collection/CollectionsHeader';

export default {
  name: 'CollectionGroup',
  components: { CollectionsHeader, CollectionItem },
  props: [
    'type',
    'num',
    'collection',
  ],
  watch: {
    RMTSearchType (to) {
      if (to === 0) {
        this.selected = undefined;
      }
    },
    selected (v) {
     gsap.to(this.$el, {
       /* border: (v ? '3' : '1') + 'px solid black',*/
        width: (v ? 100 : 48) + '%',
        duration: 0,
        ease: 'power4.inOut'
      });
      this.$refs.header.setExpand(v);
    }
  },
  computed: {
    ...mapStores(useRMTStore),
    RMTSearchType () {
      const RMTStore = useRMTStore();
      return RMTStore.getSearchType;
    },
    pointerEvents () {
      return (!this.selected) ? 'no-pointer-events' : 'pointer-events';
    },
    selected: {
      get () {
        return this.$props.collection.isSelected;
      },
      set (value) {
        this.$props.collection.isSelected = value;
      }
    },
    items () {
      return this.$props.collection.resources === undefined ? this.RMTStore.resourcesForCollection(this.$props.collection) : this.$props.collection.resources;
    }
  },
  methods: {

    handleCollectionClick () {
      this.toggleCollectionGroupExpand();
    },
    toggleCollectionGroupResize () {
/*      gsap.to(this.$el, {
        border: (highlight ? '2' : '1') + 'px solid black',
        duration: 0,
      });*/
    },
    toggleCollectionGroupExpand () {

      if (this.selected === undefined) {
        this.selected = false;
      }
      if (this.selected === false) {

        // selectedCollection

        this.RMTStore.page = 0;
        this.RMTStore.selectedCollectionColor = this.$props.collection.color;

        // todo: this is a hack until multiple collection editing is implemented (setting as an array)
        this.RMTStore.selectedCollections = [this.$props.collection];

        /*        const groupCollectionData = [];
        groupCollectionData.push({
          cID: this.$props.collection.cID,
          title: this.$props.collection.name,
          items: this.items,
          description: this.$props.collection.description,
          subscription: this.$props.collection.subscription,
          tagIds: this.$props.collection.tagIds
        });*/

        // this.RMTStore.setUploadedCollections(groupCollectionData);
        this.RMTStore.setCancelMode(1);
        this.RMTStore.panelIsHidden = false;
        this.RMTStore.updateAssociations();
        this.RMTStore.populateCollectionItemQueue();

      } else {

        this.RMTStore.page = 1;
        this.RMTStore.isAddResource = false;
        this.RMTStore.panelIsHidden = true;

      }
      this.selected = !this.selected;
    },
  }
};
</script>

<style scoped>
.collection-group {
  width: calc(50% - 10px);
  min-height: 200px;
  min-width: 50px;
  border: 1px solid lightgrey;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 5px;
  cursor:pointer;
}

.collection-items {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
}

.pointer-events {
  pointer-events: auto;
}

.no-pointer-events {
  pointer-events: none;
}

.item-count {
  align-self: flex-start;
  margin: 3px;
  font-size: .8em;
  text-align: left;
}
</style>
